import React, { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { api } from "../lib/api";

const tone = (v) => (v >= 0 ? "text-emerald-300" : "text-rose-300");
const sg = (v) => `${v >= 0 ? "+" : ""}${Number(v || 0).toFixed(2)}%`;

export const useExplainedAlerts = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    let on = true;
    const load = () => api.get("/alerts/explained").then((r) => on && setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { on = false; clearInterval(t); };
  }, []);
  return d;
};

const Alert = ({ a, i }) => (
  <div className="rounded-xl bg-white/[0.03] border border-white/5 px-3 py-2 space-y-0.5" data-testid={`explained-alert-${i}`}>
    <div className="flex items-baseline gap-2 text-sm">
      <b className="text-cyan-50">{a.symbol}</b>
      {a.held && <span className="text-[10px] px-1.5 rounded bg-[#00F0FF22] text-[#00F0FF]">HELD</span>}
      <span className="nx-mono text-cyan-100/80">${a.price}</span>
      <b className={`nx-mono ${tone(a.change_pct)}`}>{sg(a.change_pct)}</b>
      <span className={`ml-auto nx-mono text-xs ${a.volume_ratio >= 2 ? "text-amber-300" : "text-cyan-200/50"}`}>{a.volume_ratio}x vol</span>
    </div>
    <p className="text-xs text-cyan-200/70">{a.why}</p>
    <p className="text-xs text-amber-200/80">Watch: {a.watch}</p>
    {a.ai && <p className="text-xs text-cyan-50/80 italic" data-testid={`explained-alert-ai-${i}`}>{a.ai}</p>}
  </div>
);

export const ExplainedAlertsCard = () => {
  const d = useExplainedAlerts();
  const al = d?.alerts || [];
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-2" data-testid="explained-alerts-card">
      <div className="flex items-center gap-2">
        <BellRing className="w-4 h-4 text-[#00F0FF]" />
        <p className="text-xs nx-mono tracking-widest text-cyan-300/70">Explained Alerts</p>
        <span className="text-[10px] text-cyan-200/40">held + top movers · volume, 50/200-day, what to watch</span>
      </div>
      {al.length ? al.slice(0, 10).map((a, i) => <Alert key={a.symbol} a={a} i={i} />) : <p className="text-xs text-cyan-200/40">No alerts yet — refreshes every 15 min in market hours.</p>}
    </div>
  );
};
